<!-- 五级来源树形控件 -->
<template>
  <div>
    <el-input v-model="filterText" size="mini" placeholder="请输入来源名称" style="margin-bottom: 10px;" />
    <el-tree
      ref="tree"
      class="tree-box scrollBars"
      :props="treeProps"
      :data="treeData"
      show-checkbox
      :check-strictly="true"
      node-key="sourceCode"
      :default-expanded-keys="defaultExpandedKeys"
      :default-checked-keys="defaultCheckedKeys"
      :filter-node-method="filterNode"
      @node-click="handleNodeClick"
      @check-change="handleCheckChange"
    />
  </div>
</template>

<script>

export default {
  name: 'FiveSourceTree',
  // eslint-disable-next-line vue/require-prop-types
  props: ['treeData', 'checkKey'],

  data() {
    return {
      treeProps: {
        label: 'sourceName',
        children: 'children'
      },
      filterText: '',
      selectData: {}
    }
  },

  computed: {
    // 默认展开
    defaultExpandedKeys() {
      const keys = this.treeData.map(item => item.sourceCode)
      keys.push(this.checkKey)
      return keys
    },
    // 默认选中
    defaultCheckedKeys() {
      return [this.checkKey]
    }
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val)
    }
  },

  created() {
  },

  mounted() {},

  methods: {
    // 树形数据初始化，外层节点添加disabled
    formatData(params) {
      const data = params
      data.forEach((item) => {
        if (item.children.length !== 0) {
          item.disabled = true
          this.formatData(item.children)
        }
      })
      return data
    },
    // 节点被点击时的回调
    handleNodeClick(data, node) {
      if (node.level === 7) {
        node.checked = !node.checked
        this.selectData = {}
      }
    },
    // 根据节点获取父节点及以上的数据
    getParentNodeData(fiveLevelNode) {
      console.log(fiveLevelNode,'---fiveLevelNode----')
      // 初始化节点
      let node = fiveLevelNode
      let level = node.level

      // 循环向上遍历节点的父节点，直到根节点
      while (level > 1) {
        switch (level) {
          // case 7:
          //   this.selectData.fiveLevelCode = node.key
          //   this.selectData.fiveLevelName = node.label
          //   this.selectData.sourceClass = node.data.sourceClass
          //   this.selectData.belongClass = node.data.belongClass
          //   break
          // case 6:
          //   this.selectData.fourLevelCode = node.key
          //   this.selectData.fourLevelName = node.label
          //   break
          // case 5:
          //   this.selectData.threeLevelCode = node.key
          //   this.selectData.threeLevelName = node.label
          //   break
          // case 4:
          //   this.selectData.twoLevelCode = node.key
          //   this.selectData.twoLevelName = node.label
          //   break
          // case 3:
          //   this.selectData.oneLevelCode = node.key
          //   this.selectData.oneLevelName = node.label
          //   break


          case 4:
            this.selectData.threeLevelCode = node.key
            this.selectData.threeLevelName = node.label
            this.selectData.sourceClass = node.data.sourceClass
            this.selectData.belongClass = node.data.belongClass
            break
          case 3:
            this.selectData.twoLevelCode = node.key
            this.selectData.twoLevelName = node.label
            break
          case 2:
            this.selectData.oneLevelCode = node.key
            this.selectData.oneLevelName = node.label
            break
        }
        node = node.parent
        level = node.level
      }
    },
    // 节点选中状态发生变化时的回调
    handleCheckChange(data, checked) {
      
      console.log(data, checked,'---data, checked-----')
      // 选中时
      if (checked) {
        // this.$refs.tree.setCheckedKeys([data.sourceCode])
        // 根据data获取选中的node
        const node = this.$refs.tree.getNode(data)
        console.log(node,'000')

        this.getParentNodeData(node)
      }
    },
    // 对节点进行过滤
    filterNode(value, data, node) {
      // 如果搜索关键字为空，则显示所有节点
      if (!value) return true

      // 初始化父节点
      let parentNode = node.parent

      // 初始化存储节点 label 的数组，初始值为当前节点的 label
      let labels = [node.label]

      // 初始化节点层级
      let level = 1

      // 循环向上遍历节点的父节点，直到根节点
      while (level < node.level) {
        // 将父节点的 label 添加到 labels 数组中
        labels = [...labels, parentNode.label]

        // 更新父节点为当前节点的父节点
        parentNode = parentNode.parent

        // 更新层级
        level++
      }

      // 返回 labels 数组中是否有任何一个 label 包含搜索关键字
      return labels.some(label => label.indexOf(value) !== -1)
    }
  }
}
</script>

<style lang="less" scoped>
.tree-box {
  height: 55vh;
  overflow-y: auto;
  ::v-deep .el-checkbox__input.is-disabled{
    display: none;
  }
}
</style>
